import { FC, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../_metronic/helpers'
import { useDataTableStore } from '../../stores/DataTableStore'
import Swal from 'sweetalert2'
import useAccessToken from '../../hooks/AccessToken'
import { ListPhoneUsers, User } from '../../interfaces/User'
import { useCompanyStore } from '../../stores/CompanyStore'
import { useIntl } from 'react-intl'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import { handleCaps } from '../../functions/general'
import { OTPModal } from '../OTPModal'
import { Modal } from 'bootstrap'
import useHandleCloseModal from '../../hooks/HandleCloseModal'
import { createResetPasswordSession } from '../../app/modules/auth/redux/AuthCRUD'
import useUser from '../../hooks/User'
import InputPhoneNative from '../Input/InputPhoneNative'
import useCheckWa from '../../hooks/useCheckWa'
import { SelectOption } from '../../interfaces/SelectOption'
import useSWR, { mutate } from 'swr'
import axios from 'axios'
import { UserCompany } from '../../interfaces/UserCompany'
import useModalEffect from '../../hooks/useModalEffect'
import VirtualizedSelect, { VirtualizedSelectOption, VirtualizedSelectOptionsType } from '../Select/SelectVirtualized'
import { deleteOtherPhone, sendOtpOtherPhone, updateOtherPhone } from '../../api/OtherPhone'
import { sendOtpUpdateChatPhone } from '../../api/UsersCRUD'

interface Props {
  userData: User
}

const ChatSettingUser: FC<Props> = ({ userData }) => {
  const API_URL = process.env.REACT_APP_API_URL
  const closeModalRef = useRef<HTMLButtonElement>(null)
  const user = useUser()
  const token = useAccessToken()
  const intl = useIntl()

  const [isOtpModal, setIsOtpModal] = useState<boolean>(false);
  const [isOtpChatPhoneModal, setIsOtpChatPhoneModal] = useState<boolean>(false);
  const [isloadingChatPhone, setIsLoadingChatPhone] = useState<boolean>(false);
  const [chatPhone, setChatPhone] = useState<string>('');
  const { checkWa, checkWaValid } = useCheckWa({ phoneNumber: chatPhone });
  const [otherPhones, setOtherPhones] = useState<ListPhoneUsers[]>([]);
  const [optionUser, setOptionUser] = useState<SelectOption[]>([]);
  const [selectedUser, setSelectedUser] = useState<ListPhoneUsers>({} as ListPhoneUsers);
  const [requestId, setRequestId] = useState('');


  const modalRef = useRef<HTMLDivElement | null>(null);
  const closeModal = () => {
    closeModalRef.current?.click()
  }

  const fetcher = (url: string) => axios.get(url, {
    headers: {
      'X-Auth-token': token
    }
  }).then(res => res.data.data)

  const { data: usersCompany = [], isLoading: userLoadingCompany } = useSWR(`${API_URL}v2/chat/access/chat-request/users`, fetcher)

  const handleAddNewPhone = () => {
    setOtherPhones([
      { id: '', number: '', label: '', scope: 'chat', isPrimary: false, isVerify: false },
      ...otherPhones,
    ]);
  };

  const handleChangeUser = (option: SelectOption, index: number) => {
    otherPhones[index].id = option === null ? '' : option.id!
    otherPhones[index].number = option === null ? '' : option.value
    otherPhones[index].label = option === null ? '' : option.label
    setOtherPhones([...otherPhones])
  }

  const handleChangeAccess = (check: boolean, index: number) => {
    otherPhones[index].scope = check ? 'chat_view' : 'chat'
    setOtherPhones([...otherPhones])
  }

  const handleUpdateChatPhone = async () => {
    setIsLoadingChatPhone(true)
    try {
      const response = await sendOtpUpdateChatPhone(chatPhone, userData.id, token);
      if (response.data.success) {
        setRequestId(response.data.data.requestId)
        setIsOtpChatPhoneModal(true)
      }
    } catch (error: any) {
      Swal.fire({
        target: document.getElementById(`chat-setting-user-modal-${userData.id}`),
        icon: 'error',
        heightAuto: false,
        title: error.response.data.message,
        confirmButtonText: 'Ok'
      })
    } finally {
      setIsLoadingChatPhone(false)
    }
  };

  const handleVerifedPhone = async (data: ListPhoneUsers, index: number) => {
    try {
      const response = await sendOtpOtherPhone(data.id, userData.id, data.scope, token);
      if (response.data.success) {
        setRequestId(response.data.data.requestId)
        setSelectedUser(data)
        setIsOtpModal(true)
      }
    } catch (error: any) {
      Swal.fire({
        target: document.getElementById(`chat-setting-user-modal-${userData.id}`),
        icon: 'error',
        heightAuto: false,
        title: error.response.data.message,
        confirmButtonText: 'Ok'
      })
    }
  };

  const handleUpdatePhone = async (data: ListPhoneUsers, index: number) => {
    try {
      const response = await updateOtherPhone(data.id, userData.id, data.scope, token);
      if (response.data.success) {
        setOtherPhones((prev) => {
          return prev.map((item) => {
            if (item.id === response.data.data.id) {
              return { ...item, scope: data.scope }
            }
            return item
          })
        })

        mutate(`${API_URL}users`)
        Swal.fire({
          title: 'Success',
          target: document.getElementById(`chat-setting-user-modal-${userData.id}`),
          text: intl.formatMessage({ id: "FORM.VALIDATION.UPDATE_SUCCESS" }),
          icon: 'success',
          showConfirmButton: false,
          heightAuto: false,
          timer: 1500
        })
      }
    } catch (error: any) {
      Swal.fire({
        target: document.getElementById(`chat-setting-user-modal-${userData.id}`),
        icon: 'error',
        title: error.response.data.message,
        heightAuto: false,
        confirmButtonText: 'Ok'
      })
    }
  };

  const handleDeletePhone = (data: ListPhoneUsers, index: number) => {
    Swal.fire({
      title: intl.formatMessage({ id: "FORM.ACTION.DELETE" }),
      html: `<p>${intl.formatMessage({ id: "FORM.CONFIRMATION" })} ${intl.formatMessage({ id: "FORM.ACTION.DELETE" }).toLowerCase()} ${data.label} ?</p>`,
      icon: "warning",
      showCancelButton: !0,
      buttonsStyling: !1,
      confirmButtonText: intl.formatMessage({ id: "FORM.ACTION.DELETE" }),
      cancelButtonText: intl.formatMessage({ id: "FORM.CONFIRMATION.NO" }),
      showLoaderOnConfirm: true,
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-active-light',
      },
      target: document.getElementById(`chat-setting-user-modal-${userData.id}`),
      reverseButtons: true,
      heightAuto: false,
      preConfirm: async () => {
        if (data.isVerify) {
          try {
            const response = await deleteOtherPhone(data.id, userData.id, token)
            if (response.data.success) {
              const updatedPhones = [...otherPhones];
              updatedPhones.splice(index, 1);
              setOtherPhones(updatedPhones);
              mutate(`${API_URL}users`)

              Swal.fire({
                title: 'Success',
                target: document.getElementById(`chat-setting-user-modal-${userData.id}`),
                text: intl.formatMessage({ id: "FORM.VALIDATION.DELETE_SUCCESS" }),
                icon: 'success',
                showConfirmButton: false,
                heightAuto: false,
                timer: 1500
              })
            }
          } catch (error: any) {
            Swal.fire({
              target: document.getElementById(`chat-setting-user-modal-${userData.id}`),
              icon: 'error',
              heightAuto: false,
              title: error.response.data.message,
              confirmButtonText: 'Ok',
            })
          }
        } else {
          const updatedPhones = [...otherPhones];
          updatedPhones.splice(index, 1);
          setOtherPhones(updatedPhones);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    })
  };

  const CustomSelectUserOption = (props: { option: VirtualizedSelectOptionsType; onClick?: () => void }) => {
    const { option } = props;

    return (
      <div className="d-flex align-items-center px-3 h-100" style={{ cursor: 'pointer', background: option.value === 'chocolate' ? '#d9d9d9' : 'transparent', }}>
        <span className="align-middle">{option!.name} / <b>{option!.value}</b></span>
      </div>
    );
  }

  const CustomSelectSingleUserValue = (props: { value: VirtualizedSelectOptionsType; placeholder?: string }) => {
    const { value, placeholder } = props;
    if (!value?.value) return <span>{placeholder}</span>

    return (
      <span className="align-middle">{value!.name} / <b>{value!.value}</b></span>
    );
  }

  useEffect(() => {
    if (userData) {
      let phone = userData.phones.find((phone) => !phone.isPrimary && phone.id === userData.id);

      let otherPhones = userData.phones
        .filter((phone) => !phone.isPrimary && phone.id !== userData.id)
        .map((phone) => ({
          ...phone,
          isVerify: true,
        }));

      setChatPhone(phone?.number || '');
      setOtherPhones(otherPhones);
    }
  }, [userData]);

  useEffect(() => {
    if (!userLoadingCompany) {
      const options = usersCompany.map((user: UserCompany) => ({
        id: user.id,
        name: user.name,
        value: user.phone,
        label: user.name + ' - ' + user.phone,
      }))
      setOptionUser(options)
    }
  }, [usersCompany]);

  useModalEffect({
    showModal: isOtpModal,
    setShowModal: setIsOtpModal,
    modalId: `otp-modal-chatOtherPhoneUser`
  })

  useModalEffect({
    showModal: isOtpChatPhoneModal,
    setShowModal: setIsOtpChatPhoneModal,
    modalId: `otp-modal-chatPhoneUser`
  })

  return (
    <>
      <div className='modal fade' tabIndex={-1} id={`chat-setting-user-modal-${userData.id}`} ref={modalRef}>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>
                {intl.formatMessage({ id: 'FORM.ACTION.CHAT_SETTINGS' })} {userData.name}
              </h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className="modal-body fs-6">
              <label className="form-label fs-6 fw-bolder text-dark">{intl.formatMessage({ id: "FORM.LABEL.CHAT_PHONE" })}</label>
              <div className="flex-grow-1">
                <div className="d-flex justify-content-center align-items-center gap-3">
                  <InputPhoneNative
                    value={chatPhone}
                    setValue={(val) => {
                      setChatPhone(val);
                    }}
                    checkWaValid={checkWaValid}
                  />
                  <button type="button" onClick={() => handleUpdateChatPhone()} className={`btn btn-primary btn-sm ${isloadingChatPhone ? "disabled" : ""}`} data-kt-indicator={isloadingChatPhone ? 'on' : 'off'} style={{ minWidth: "130px" }}>
                    <span className="indicator-label">
                      {intl.formatMessage({ id: 'FORM.ACTION.UPDATE' })}
                    </span>
                    <span className="indicator-progress">
                      Loading... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  </button>
                </div>
                {checkWa && (
                  <div className={`mt-1 ${checkWa === 'true' ? 'text-success' : 'text-danger'}`}>
                    {checkWa === 'true'
                      ? intl.formatMessage({ id: "FORM.VALIDATION.VALID_WHATSAPP" })
                      : checkWa === 'false'
                        ? intl.formatMessage({ id: "FORM.VALIDATION.INVALID_WHATSAPP" })
                        : null
                    }
                  </div>
                )}
                <div className="separator separator-dashed my-5"></div>
                <div className="mt-3 mb-3 d-flex justify-content-between align-items-center">
                  <label className="form-label mb-0 fs-6 fw-bolder text-dark">{intl.formatMessage({ id: "FORM.LABEL.OTHER_PHONE" })}</label>
                  <button type="button" className="btn btn-primary btn-sm" onClick={handleAddNewPhone}>
                    <i className="fas fa-plus"></i> {intl.formatMessage({ id: "FORM.ACTION.ADD" })}
                  </button>
                </div>
              </div>
              {otherPhones.map((data, index) => {
                const selectedNumbers = otherPhones.filter((_, i) => i !== index).map(item => item.number);
                const filteredOptions = optionUser.filter(option => !selectedNumbers.includes(option.value));

                return (
                  <div key={data.id + index} className="mb-3 align-items-center">
                    <div className='d-flex gap-2 align-items-center mb-1'>
                      <VirtualizedSelect
                        options={filteredOptions}
                        isLoading={userLoadingCompany}
                        className="w-100"
                        placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: 'FORM.LABEL.USER' })}`}
                        value={optionUser.find(option => option.id === data.id) || null}
                        onChange={(option: VirtualizedSelectOption) => handleChangeUser(option, index)}
                        isDisabled={data.isVerify}
                        isClearable={!data.isVerify}
                        components={{
                          Option: CustomSelectUserOption,
                          SingleValue: CustomSelectSingleUserValue,
                        }}
                      />
                      {!data.isVerify && data.number && (
                        <button
                          type="button"
                          className="btn btn-light-success btn-icon"
                          style={{ height: '40px' }}
                          onClick={() => handleVerifedPhone(data, index)}
                        >
                          <i className="fas fa-check-double"></i>
                        </button>
                      )}
                      {data.isVerify && data.number && (
                        <button
                          type="button"
                          className="btn btn-light-primary btn-icon"
                          style={{ height: '40px' }}
                          onClick={() => handleUpdatePhone(data, index)}
                        >
                          <i className="fas fa-check-double"></i>
                        </button>
                      )}
                      {data.id !== user.data.id && (
                        <button
                          type="button"
                          className="btn btn-light-danger btn-icon"
                          style={{ height: '40px' }}
                          onClick={() => handleDeletePhone(data, index)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      )}
                    </div>
                    <label className="form-check form-check-inline form-check-solid me-5 is-invalid">
                      <input className="form-check-input" type="checkbox" onChange={(e) => handleChangeAccess(e.target.checked, index)} value={data.scope} checked={data.scope === "chat_view" ? true : false} />
                      <span className="ps-2 fs-7">Hanya Lihat</span>
                    </label>
                  </div>
                )
              })}
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-light'
                ref={closeModalRef}
                data-bs-dismiss='modal'
              >
                {intl.formatMessage({ id: 'FORM.ACTION.CLOSE' })}
              </button>
            </div>
          </div>
        </div>
      </div>
      {
        isOtpModal && <OTPModal username={user.data.username} password="" phone={selectedUser.number} type={"chatOtherPhoneUser"} data={{ ownerId: selectedUser.id, granteeId: userData.id, scope: selectedUser.scope }} requestId={requestId} setOtherPhones={setOtherPhones} />
      }
      {
        isOtpChatPhoneModal && <OTPModal username={user.data.username} password="" phone={chatPhone} type={"chatPhoneUser"} requestId={requestId} userId={userData.id} />
      }
    </>
  )
}

export { ChatSettingUser }
